import { setAccount, syncEntitlements, type AccountInfo } from './access';
import { rememberRoomKey } from './relayKey';
import { saveSettings, applyRemoteSettings } from './settings';
import { currentSession } from '../core/Session';

/** What /api/auth/verify (and the QR link status) hands back. */
export interface AccountPayload {
  email: string;
  userId?: string;
  room?: string;
  /** the key the relay demands for that room (only the server can compute it) */
  roomKey?: string;
  settings?: unknown;
  admin?: boolean;
  adminToken?: string;
  /** server truth: this verify CREATED the account (first code ever) — the UI greets new vs returning */
  created?: boolean;
}

/** Store the account on this browser, adopt its relay room + settings, restore purchases. */
export async function adoptAccount(j: AccountPayload): Promise<AccountInfo> {
  const info: AccountInfo = { email: j.email, userId: j.userId, room: j.room, roomKey: j.roomKey, admin: !!j.admin, adminToken: j.adminToken };
  setAccount(info);
  if (j.room) {
    // the phone app publishes into the account room → the car follows it automatically
    rememberRoomKey(j.room, j.roomKey ?? '');
    saveSettings({ relayRoom: j.room });
    currentSession()?.setRelayRoom(j.room);
  }
  const patch = applyRemoteSettings(j.settings);
  const ses = currentSession();
  if (ses) {
    if (patch.volume != null) ses.setVolume(patch.volume);
    if (patch.vehicleTopSpeedKmh != null) ses.setTopSpeed(patch.vehicleTopSpeedKmh);
    if (patch.gearbox) ses.setGearbox(patch.gearbox);
    if (patch.driveStyle) ses.setDriveStyle(patch.driveStyle);
  }
  await syncEntitlements();
  return info;
}
